module.exports = __webpack_public_path__ + "img/e2i_Logo2White_updated.69a47101.png";